import { createContext, useContext } from 'react';

interface PageInformationType {
  mainPageTitle: string;
  subPageTitle?: string;
}

export const PageInformationContext = createContext<PageInformationType | undefined>(undefined);

export const usePageInformationContext = () => {
  const context = useContext(PageInformationContext);
  if (!context) throw new Error('usePageInformationContext must be used within Provider');
  return context;
};
